import script from "./BirthRecordFormEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./BirthRecordFormEditor.vue?vue&type=script&lang=ts&setup=true"

import "./BirthRecordFormEditor.vue?vue&type=style&index=0&id=0ef70341&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ef70341"]])

export default __exports__